export class Stage5 {
    validate() {
        // return [
        //     'subscription',
        // ];
        
        // delegateDetails
        let dds = Alpine.store('status').currentDelegate().additional_details;
        
        
        return (typeof dds.subscription !== 'undefined' && dds.subscription.length > 0);
    }
}